export default {
    name: ["", ""],
    headTitle: ["Enterprise Profile Management Portal - ENTERPRISE TECH PLATFORM", "ប្រព័ន្ធគ្រប់គ្រងទំព័រសហគ្រាស - ថ្នាលបច្ចេកវិទ្យាសហគ្រាស"],
    loading: ["Loading Profile Management Portal", "កំពុងដំណើរការប្រព័ន្ធគ្រប់គ្រងទំព័រ"],
    expired: ["Your session is expired.", "ការប្រើប្រាស់របស់អ្នកត្រូវបានផុតកំណត់។"],
    goHome: ["Redirecting to home page ...", "កំពុងទៅកាន់ទំព័រដើម ..."],
    myProfile: ["My Profile", "ទំព័ររបស់ខ្ញុំ"],
    profileInformation: ["Profile Information", "ព័ត៌មានអំពីទំព័រ"],
    profileStatistics: ["Profile Statistics", "ស្ថិតិអំពីទំព័រ"],
    profileActivity: ["Profile Activities", "សកម្មភាពរបស់ទំព័រ"],
    productServices: ["Products & Services", "ផលិតផល & សេវាកម្ម"],
    requestQuotation: ["Quotation & Bidding", "ការដេញថ្លៃ"],
    jobRecruitment: ["Recruitment", "ការជ្រើសរើសបុគ្គលិក"],
    scholarshipOffer: ["Scholarship", "អាហារូបករណ៍"],
    profileManager: ["Profile Managers", "អ្នកគ្រប់គ្រងទំព័រ"],
    required: ["* required", "* តម្រូវបំពេញ"],
    allProduct: ["All My Products & Services", "ផលិតផល និងសេវាកម្មទាំងអស់"],
    allQuotation: ["All My Request for Quotation & Bidding", "ការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃទាំងអស់"],
    allJob: ["All My Job Recruitment", "ការជ្រើសរើសបុគ្គលិកទាំងអស់"],
    allScholarship: ["All My Scholarship", "ការផ្តល់ជូនអាហារូបករណ៍ទាំងអស់"],
    allActivity: ["All My Activities", "សកម្មភាពរបស់ទំព័រទាំងអស់"],
    allManager: ["All My Managers", "អ្នកគ្រប់គ្រងទំព័រទាំងអស់"],
    all: ["All", "ទាំងអស់"],
    status: ["Status", "ស្ថានភាព"],
    action: ["Action", "សកម្មភាព"],
    lastUpdate: ["Last Updated", "កែប្រែចុងក្រោយ"],
    title: ["Title", "ចំណងជើង"],
    category: ["Category", "ប្រភេទ"],
    product: ["Product", "ផលិតផល"],
    service: ["Service", "សេវាកម្ម"],
    thumbnail: ["Thumbnail", "រូបភាព"],
    price: ["Price", "តម្លៃ"],
    disabled: ["Disabled", "មិនដំណើរការ"],
    active: ["Active", "ដំណើរការ"],
    showMore: ["Show more", "បង្ហាញបន្ថែម"],
    statusAll: ["Status (All)", "ស្ថានភាព (ទាំងអស់)"],
    typeAll: ["Type (All)", "ប្រភេទ (ទាំងអស់)"],
    type: ["Type", "ប្រភេទ"],
    newProduct: ["new product or service", "បង្កើតផលិតផល ឬសេវាកម្មថ្មី"],
    searchProduct: ["Search Product or Service", "ស្វែងរកផលិតផល ឬសេវាកម្ម"],
    newQuotation: ["new request for quotation or bidding", "បង្កើតការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    searchQuotation: ["Search Quotation & Bidding", "ស្វែងរកការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    newJob: ["new job recruitment", "បង្កើតការជ្រើសរើសបុគ្គលិក"],
    searchJob: ["Search Job Recruitment", "ស្វែងរកការជ្រើសរើសបុគ្គលិក"],
    newActivity: ["new activity", "បង្កើតសកម្មភាពថ្មី"],
    searchActivity: ["Search Profile Activity", "ស្វែងរកសកម្មភាព"],
    newScholarship: ["new scholarship offer", "បង្កើតការផ្តល់អាហារូបករណ៍"],
    searchScholarship: ["Search Scholarship Offer", "ស្វែងរកការផ្តល់អាហារូបករណ៍"],
    notAvailable: ["Not Available", "មិនមាន"],
    drafted: ["Drafted", "បានព្រាង"],
    deadline: ["Deadline", "ផុតកំណត់"],
    search: ["Search", "ស្វែងរក"],
    editThis: ["Edit", "កែប្រែ "],
    enableThis: ["Enable", "ដាក់ដំណើរការ "],
    deleteThis: ["Delete", "លុប "],
    disableThis: ["Disable", "បញ្ចប់ដំណើរការ "],
    viewThis: ["View", "មើល "],
    publishThis: ["Publish", "ដាក់ដំណើរការ "],
    noScholarship: ["You don't have any scholarship offers.", "អ្នកមិនមានការផ្តល់អាហារូបករណ៍"],
    noActivity: ["You don't have any activities.", "ទំព័ររបស់អ្នកមិនមានសកម្មភាពនានាទេ"],
    noJob: ["You don't have any job recruitment.", "ទំព័ររបស់អ្នកមិនមានការជ្រើសរើសបុគ្គលិកទេ"],
    noQuotation: ["You don't have any quotation/bidding.", "ទំព័ររបស់អ្នកមិនមានការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃទេ"],
    noProduct: ["You don't have any products & services.", "ទំព័ររបស់អ្នកមិនមានផលិតផល ឬសេវាកម្មទេ"],
    deleteJob: ["Are you sure want to delete this job recruitment ?", "តើអ្នកពិតជាចង់លុបការជ្រើសរើសបុគ្គលិកនេះមែនទេ ?"],
    disableJob: ["Are you sure want to disable this job recruitment", "តើអ្នកពិតជាចង់បញ្ចប់ការជ្រើសរើសបុគ្គលិកនេះមែនទេ ?"],
    deleteScholarship: ["Are you sure want to delete this scholarship offer ?", "តើអ្នកពិតជាចង់លុបការផ្តល់អាហារូបករណ៍នេះមែនទេ ?"],
    disableScholarship: ["Are you sure want to disable this scholarship offer ?", "តើអ្នកពិតជាចង់បញ្ចប់ការផ្តល់អាហារូបករណ៍នេះមែនទេ ?"],
    deleteQuotation: ["Are you sure want to delete this quotation/bidding ?", "តើអ្នកពិតជាចង់លុបការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃនេះមែនទេ ?"],
    disableQuotation: ["Are you sure want to disable this quotation/bidding ?", "តើអ្នកពិតជាចង់បញ្ចប់ការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃនេះមែនទេ ?"],
    deleteProduct: ["Are you sure want to delete this product ?", "តើអ្នកពិតជាចង់លុបផលិតផល ឬសេវាកម្មនេះមែនទេ ?"],
    disableProduct: ["Are you sure want to disable this product ?", "តើអ្នកពិតជាចង់បញ្ចប់ផលិតផល ឬសេវាកម្មនេះមែនទេ ?"],
    disable: ["Disable", "បញ្ចប់ដំណើរការ"],
    delete: ["Delete", "លុបចេញ"],
    cancel: ["Cancel", "បោះបង់"],
    profileImage: ["Profile Image Logo (square photo)", "រូបភាពសញ្ញារបស់ទំព័រ (រូបថតការ៉េ)"],
    generalInformation: ["General Information", "ព័ត៌មានទូទៅ"],
    profileName: ["Profile Name", "ឈ្មោះទំព័រ"],
    profileType: ["Profile Type", "ប្រភេទទំព័រ"],
    establishedYear: ["Established Year", "ឆ្នាំ​បង្កើត"],
    totalStaff: ["Total Staff", "បុគ្គលិកសរុប"],
    profileDescription: ["Profile Description (min 100 characters, max 2000 characters)", "បរិយាយអំពីទំព័រ (អប្បបរមា 100 តួអក្សរ អតិបរមា 2000 តួអក្សរ)"],
    profileSector: ["Profile Sector", "វិស័យរបស់ទំព័រ"],
    contactInformation: ["Contact Information", "ព័ត៌មានទំនាក់ទំនង"],
    addressProvince: ["Address Province / City", "អាស័យដ្ឋាន ខេត្ត/ក្រុង"],
    addressDistrict: ["Address District", "អាស័យដ្ឋាន ស្រុក/ខណ្ឌ"],
    fullAddress: ["Full Address", "អាស័យដ្ឋានពេញ"],
    phoneNumber: ["Phone Number (+855 XX XXX XXX, +855 XX XXX XXX)", "លេខទូរសព្ទ (+855 XX XXX XXX, +855 XX XXX XXX)"],
    email: ["Email (name@mail.com)", "អុីម៉ែល (name@mail.com)"],
    website: ["Website (https://example.com)", "គេហទំព័រ (https://example.com)"],
    uploadNewLogo: ["Upload New Logo", "ផ្ទុករូបភាពសញ្ញារបស់ទំព័រថ្មី"],
    updateProfile: ["Update My Profile", "កែប្រែព័ត៌មានទំព័រ"],
    createProduct: ["Create New Product/Service", "បង្កើតផលិតផល/សេវាកម្ម"],
    updateProduct: ["Update Product/Service", "កែប្រែផលិតផល/សេវាកម្ម"],
    productInformation: ["Product/Service Information", "ព័ត៌មានផលិតផល/សេវាកម្ម"],
    productType: ["Type", "ប្រភេទ"],
    productName: ["Title", "ឈ្មោះផលិតផល/សេវាកម្ម"],
    productCategory: ["Product/Service Category", "ប្រភេទផលិតផល/សេវាកម្ម"],
    productSubCategory: ["Product/Service Sub-Category", "ប្រភេទរងផលិតផល/សេវាកម្ម"],
    productPriceType: ["Product/Service Price Type", "ប្រភេទតម្លៃរបស់ផលិតផល/សេវាកម្ម"],
    productPrice: ["Product/Service Price (USD)", "តម្លៃរបស់ផលិតផល/សេវាកម្ម"],
    productThumbnail: ["Product/Service Thumbnail", "រូបភាពតំណាងផលិតផល/សេវាកម្ម"],
    productGallery: ["Product/Service Gallery", "រូបភាពនានារបស់ផលិតផល/សេវាកម្ម"],
    upload: ["Upload", "ផ្ទុកឡើង"],
    createNewRequestQuotation: ["Create Request for Quotation/Bidding", "បង្កើតការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    quotationInformation: ["Quotation/Bidding Information", "ព័ត៌មានអំពីការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    quotationName: ["Title", "ចំណងជើងការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    quotationCategory: ["Quotation/Bidding Category *", "ប្រភេទ"],
    quotationSubCategory: ["Quotation/Bidding Sub-Category", "ប្រភេទរង"],
    quotationLocation: ["Quotation/Bidding Location", "ទីតាំងតំបន់"],
    quotationDeadline: ["Quotation/Bidding Deadline", "ផុតកំណត់"],
    quotationAttachment: ["Quotation/Bidding Attachments", "ឯកសារភ្ជាប់ការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    saveDraft: ["save as a draft", "រក្សាទុកព្រាង"],
    updateQuotation: ["Update Quotation/Bidding", "កែប្រែការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    editQuotation: ["Edit Request for Quotation/Bidding", "កែប្រែការស្នើសុំសម្រង់តម្លៃ និងដេញថ្លៃ"],
    createJob: ["Create New Recruitment", "បង្កើតការជ្រើសរើសបុគ្គលិក"],
    jobInformation: ["Recruitment Information", "ព័ត៌មានអំពីការជ្រើសរើសបុគ្គលិក"],
    jobName: ["Title", "ចំណងជើង"],
    jobCategory: ["Job Category", "ប្រភេទការងារ"],
    jobSubCategory: ["Job Sub-Category", "ប្រភេទរងការងារ"],
    jobType: ["Job Type", "ប្រភេទ​ការងារ"],
    jobSkill: ["Job Skill Level", "កម្រិតជំនាញ"],
    jobQualification: ["Job Qualification", "លក្ខណៈសម្បត្តិ"],
    jobSalary: ["Job Salary", "ប្រាក់ខែ"],
    jobLocation: ["Job Location", "ទីតាំងតំបន់"],
    jobDeadline: ["Job Deadline", "ផុតកំណត់"],
    jobAttachment: ["Job Attachments", "ឯកសារភ្ជាប់"],
    updateJob: ["Update Recruitment", "កែប្រែការជ្រើសរើសបុគ្គលិក"],
    editJob: ["Edit Recruitment", "កែប្រែការជ្រើសរើសបុគ្គលិក"],
    createScholarship: ["Create New Scholarship", "បង្កើតការផ្តល់ជូនអាហារូបករណ៍"],
    scholarshipInformation: ["Scholarship Information", "ព័ត៌មានអំពីការផ្តល់ជូនអាហារូបករណ៍"],
    scholarshipName: ["Title *", "ឈ្មោះការផ្តល់ជូនអាហារូបករណ៍"],
    scholarshipType: ["Scholarship Type *", "ប្រភេទការផ្តល់ជូនអាហារូបករណ៍"],
    scholarshipLocation: ["Scholarship Location", "ប្រទេស"],
    scholarshipDegree: ["Scholarship Degree", "សញ្ញាបត្រ"],
    scholarshipDeadline: ["Scholarship Deadline", "ផុតកំណត់"],
    scholarshipAttachment: ["Scholarship Attachments", "ឯកសារការផ្តល់ជូនអាហារូបករណ៍"],
    updateScholarship: ["Update Scholarship", "កែប្រែការផ្តល់ជូនអាហារូបករណ៍"],
    editScholarship: ["Edit Scholarship", "កែប្រែការផ្តល់ជូនអាហារូបករណ៍"],
    newActivity: ["Create New Activity", "បង្កើតសកម្មភាពថ្មី"],
    activityInformation: ["Activity Information", "ព័ត៌មានអំពីសកម្មភាព"],
    activityName: ["Title", "ចំណងជើង"],
    activityThumbnail: ["Activity Thumbnail", "រូបភាពតំណាងសកម្មភាព"],
    activityGallery: ["Activity Gallery", "បណ្តុំរូបភាពសកម្មភាព"],
    updateActivity: ["Update Activity", "កែប្រែសកម្មភាព"],
    viewThisProfile: ["View this profile", "មើលទំព័ររបស់ខ្ញុំ"],
    logout: ["Log Out", "ចាកចេញពីប្រព័ន្ធ"],
    system: ["ENTERPRISE TECH PLATFORM", "ថ្នាលបច្ចកវិទ្យាសហគ្រាស"],
    headerGo: ["Home", "ទំព័រដើម"],
    total: ["Total ", "ចំនួន"],
    searchManager: ["Search Member by Name or Contact", "ស្វែងរកអ្នកគ្រប់គ្រង"],
    addNewManager: ["Add new manager", "បន្ថែមអ្នកគ្រប់គ្រងថ្មី"],
    userName: ["Manager", "ឈ្មោះអ្នកគ្រប់គ្រង"],
    userContact: ["Contact", "ទំនាក់ទំនង"],
    userRole: ["Role", "តួនាទី"],
    roleSuperAdmin: ["Super Administrator", "អ្នកគ្រប់គ្រងជាន់ខ្ពស់"],
    roleAdmin: ["Administrator", "អ្នកគ្រប់គ្រង"],
    roleEditor: ["Content Editor", "អ្នកបង្កើតមតិកា"],
    total_apply: ["Applies", "ចំនួនពាក្យ"],
    application: ["applications", "ពាក្យ"],
    viewSubmission: ["View application submission", "មើលការដាក់ពាក្យ"],
    notApplicationAvailable: ["Not submission available.", "មិនមានពាក្យ"],
    quotationSubmission: ["Quotation Submission", "ការដាក់ពាក្យ"],
    jobSubmission: ["Recruitment Submission", "ការដាក់ពាក្យ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
}


// WEBPACK FOOTER //
// ./src/config/locale.js